import React, { useState, useEffect } from 'react';

const projectData = [
  {
    title: "mikusiek",
    images: [
      'https://i.imgur.com/kr9KfXE.png',
    ],
    link: "https://mikusiek.netlify.app",
    description: "Strona z odnosnikami do social mediów i portfolio."
  },
  {
    title: "76mikus",
    images: [
      'https://i.imgur.com/2yLefDG.png',
    ],
    link: "https://76mikus.space",
    description: "Strona z odnosnikami do social mediów i portfolio."
  },
  {
    title: "Czoperownia",
    images: [
      'https://i.imgur.com/9cEAonI.png',
      'https://i.imgur.com/VR9ygWZ.png'
    ],
    link: "https://czoperownia.netlify.app/",
    description: "Strona internetowa dla serwera discord Czoperownia. Zawiera odnosnik z zaproszeniem do serwera oraz pod spodem smieszny napis pojawiajacy sie w stylu typing."
  },
];

const Projects = () => {
  const [activeProject, setActiveProject] = useState(null);
  const [imageIndex, setImageIndex] = useState(0);

  useEffect(() => {
    if (activeProject !== null) {
      const interval = setInterval(() => {
        setImageIndex(prev => (prev + 1) % projectData[activeProject].images.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [activeProject]);

  return (
    <div className="projects-container">
      <h2 class="typing-title">Nasze Projekty</h2>
      <div className="project-grid">
        {projectData.map((project, index) => (
          <div
            key={index}
            className="project-card"
            onClick={() => {
              setActiveProject(index);
              setImageIndex(0);
            }}
          >
            <img src={project.images[0]} alt={project.title} />
            <h3>{project.title}</h3>
          </div>
        ))}
      </div>

      {activeProject !== null && (
        <div className="project-modal">
          <div className="modal-content">
            <button className="close-button" onClick={() => setActiveProject(null)}>×</button>
            <img
              className="modal-image"
              src={projectData[activeProject].images[imageIndex]}
              alt="Podgląd projektu"
            />
            <h2>{projectData[activeProject].title}</h2>
            <a href={projectData[activeProject].link} target="_blank" rel="noopener noreferrer">
              Odwiedź stronę →
            </a>
            <p>{projectData[activeProject].description}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Projects;
